<template>
    <g-tag v-if="show" :theme="color"> {{ label }} </g-tag>
</template>

<script>
    import { ref, computed } from 'vue-demi';
    import {
        ACTIVATION_BRIEF_STATUS_NONE,
        ACTIVATION_BRIEF_STATUS_NEW,
        ACTIVATION_BRIEF_STATUS_LABELS,
        ACTIVATION_BRIEF_STATUS_COLORS,
        ACTIVATION_BRIEF_STATUS_ARCHIVED,
        ACTIVATION_BRIEF_STATUS_COMPLETE
    } from '../../constants/activation-brief';

    export default {
        name: 'BriefStatus',

        props: {
            brief: {
                type: Object,
                required: true
            },
            showNew: {
                type: Boolean,
                default: false
            }
        },

        setup(props) {
            const status = ref(props.brief.status);
            if (status.value === ACTIVATION_BRIEF_STATUS_NONE) {
                status.value = ACTIVATION_BRIEF_STATUS_NEW;
            }

            const label = computed(() => {
                // If the parent activation status is archived, return the label for the complete status
                if (ACTIVATION_BRIEF_STATUS_ARCHIVED === props.brief?.activation?.status) {
                    return ACTIVATION_BRIEF_STATUS_LABELS[ACTIVATION_BRIEF_STATUS_COMPLETE];
                }
                return ACTIVATION_BRIEF_STATUS_LABELS[status.value];
            });

            const color = computed(() => {
                return ACTIVATION_BRIEF_STATUS_COLORS[status.value];
            });

            const show = computed(() => {
                return status.value !== ACTIVATION_BRIEF_STATUS_NEW || props.showNew;
            });

            return {
                label,
                color,
                show
            };
        }
    };
</script>
